module.exports = __webpack_public_path__ + "static/main_mono.60f62741.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/main_mono.png
// module id = 162
// module chunks = 35783957827783 114276838955818 267625579013595